<script setup>
import { ref } from 'vue'
import LayoutFooter from '@/components/layout/layoutFooter.vue'
import layoutShell from '@/components/layout/layoutShell.vue'
import compPostsTable from '@/components/hackwatch/posts/compPostsTable.vue'
import compPostsStatsPanel from '@/components/hackwatch/posts/compPostsStatsPanel.vue'

const tableRef     = ref(null)
const tableFilters = ref({})
</script>
<template>
  <layoutShell>
    <div class="layout-content-wrapper">
      <main class="content">
        <div class="grid">
          <div class="col-12 xl:col-9">
            <compPostsTable ref="tableRef" @filters-change="f => tableFilters = f" />
          </div>
          <div class="col-12 xl:col-3">
            <compPostsStatsPanel
              :active-filters="tableFilters"
              @filter="f => tableRef?.applyExternalFilter(f)"
            />
          </div>
        </div>
      </main>
    </div>
    <div class="layout-footer">
      <LayoutFooter />
    </div>
  </layoutShell>
</template>



